const html = require('choo/html')
const PanelElement = require('../elements/panel.js')
const CarouselElement = require('../elements/carousel.js')
const InputOption = require('../elements/inputoption.js')
const InputText = require('../elements/inputtext.js')
const InputSlider = require('../elements/inputslider.js')
const InputSprite = require('../elements/inputsprite.js')
const InputTime = require('../elements/inputtime.js')
const Button = require('../elements/button.js')
const BOOL_OPTIONS = [
  { value: 'true', label: 'true' },
  { value: 'false', label: 'false' }
]

const KEY_OPTIONS = [
  {
    label: 'left arrow',
    value: 'left arrow'
  },
  {
    label: 'right arrow',
    value: 'right arrow'
  },
  {
    label: 'up arrow',
    value: 'up arrow'
  },
  {
    label: 'down arrow',
    value: 'down arrow'
  },
  {
    label: 'space',
    value: 'space'
  },
  {
    label: 'w',
    value: 'w'
  },
  {
    label: 'a',
    value: 'a'
  },
  {
    label: 's',
    value: 's'
  },
  {
    label: 'd',
    value: 'd'
  },
  {
    label: 'f',
    value: 'f'
  },
  {
    label: 'g',
    value: 'g'
  },
  {
    label: 'CLICK',
    value: 'CLICK'
  },
  {
    label: 'none',
    value: 'none'
  }
]

function generateListInput (variable, gameVariable, target, state, emit) {
  const { input } = gameVariable
  const inputs = []
  variable.value.forEach((value, index) => {
    let label = variable.name
    if (index > 0) {
      label = null
    }
    const commonProps = {
      ...input,
      label,
      value,
      onChange: () => emit('stop-changing-variable', target, variable),
      onInput: e => emit(
        'set-list-value',
        target,
        variable,
        index,
        e.target.value
      )
    }
    inputs.push(InputText({
      ...commonProps,
      disabled: state.selectedVariableId !== null
        || state.isMenuOpen,
      onKeyDown: e => e.stopPropagation(),
      onKeyUp: e => e.stopPropagation()
    }))
  })
  inputs.push(new Button({
    text: 'add value',
    onClick: () => emit('add-item-to-list', target, variable)
  }))
  return inputs
}

function generateInputElement (gameVariable, target, state, emit) {
  const { input, id } = gameVariable

  const variable = target.variables[id]
  if (variable.type === 'list') {
    return generateListInput(variable, gameVariable, target, state, emit)
  }
  function setVariable (value) {
    emit('set-variable', target, variable, value)
  }
  const commonProps = {
    ...input,
    label: variable.name,
    value: variable.value,
    disabled: state.selectedVariableId !== null
      || state.isMenuOpen,
    onChange: () => emit('stop-changing-variable', target, variable),
    onInput: e => setVariable(e.target.value)
  }
  if (input.type === 'slider') {
    return InputSlider({ ...commonProps })
  }
  if (input.type === 'option'
    || input.type === 'key'
    || input.type === 'boolean') {
    let { options } = input
    if (input.type === 'key') {
      options = KEY_OPTIONS
    } else if (input.type === 'boolean') {
      options = BOOL_OPTIONS
    }

    let selectedItem = options.findIndex(
      o => o.value === variable.value
    )
    if (!selectedItem) {
      selectedItem = 0
    }
    if (options.length === 0) {
      return null
    }
    return InputOption({
      ...commonProps,
      options,
      selectedItem,
      onChange: index => {
        setVariable(options[index].value)
        emit('stop-changing-variable', target, variable)
      }
    })
  }
  if (input.type === 'text') {
    return InputText({
      ...commonProps,
      onKeyDown: e => e.stopPropagation(),
      onKeyUp: e => e.stopPropagation()
    })
  }
  if (input.type === 'sprite') {
    if (state.selectedVariableId === id) {
      commonProps.value = 'CLICK ON A SPRITE'
      commonProps.disabled = false
    }
    return InputSprite({
      ...commonProps,
      onSelect: () => emit('start-setting-sprite-variable', variable.id)
    })
  }
  if (input.type === 'time') {
    return InputTime({
      ...commonProps,
      onInput: e => setVariable(e.target.value),
      onKeyDown: e => e.stopPropagation(),
      onKeyUp: e => e.stopPropagation()
    })
  }
  return null
}

function paginateInputs (inputs, itemsPerPage) {
  const pages = []
  let pageIndex = 0
  pages[0] = []
  for (let i = 0; i < inputs.length; i++) {
    if (pages[pageIndex].length === itemsPerPage) {
      pageIndex += 1
      pages[pageIndex] = []
    }
    pages[pageIndex].push(inputs[i])
  }

  const items = pages.map(p => html`<div class="info">${p}</div>`)
  return items
}

function getExposedVariableWithIds (gameVariables, target) {
  return gameVariables.reduce(
    (acc, exposedVariable) => {
      // Find variable in scratch sprite
      const gameVariable = Object.values(target.variables).find(
        v => v.name === exposedVariable.variableName
      )
      // Include the scratch variable id on exposed variable info
      if (gameVariable) {
        exposedVariable.id = gameVariable.id
        acc.push(exposedVariable)
      }
      return acc
    },
    []
  )
}

function getGlitchVariables (target, glitchApplication, availableGlitches) {
  const glitch = availableGlitches.find(
    g => g.id === glitchApplication.glitchId
  )
  const exposedVariables = glitch.exposedVariables.filter(
    v => v.spriteName === '$glitch_target'
  ).map(
    v => ({
      ...v,
      spriteName: target.sprite.name
    })
  )
  return getExposedVariableWithIds(exposedVariables, target)
}

function getGameVariables (target, projectMetadata, addedParts) {
  const exposedVariablesUnfiltered = projectMetadata.exposedVariables
  const conditionsNotMet = []
  exposedVariablesUnfiltered.forEach(exposedVariable => {
    if (exposedVariable.spriteName === target.sprite.name
      && exposedVariable.condition) {
      const tVar = Object.values(target.variables).find(
        v => v.name === exposedVariable.condition.varName
      )
      if (tVar.value !== exposedVariable.condition.value) {
        conditionsNotMet.push(exposedVariable)
      }
    }
  })

  let exposedVariables = exposedVariablesUnfiltered.filter(
    v => !conditionsNotMet.includes(v)
  )
  const selectedPart = addedParts.find(
    p => p.spriteName === target.sprite.name
  )
  if (selectedPart) {
    ({ exposedVariables } = selectedPart)
  }
  if (exposedVariables) {
    exposedVariables = exposedVariables.filter(
      v => v.spriteName === target.sprite.name
    )
  } else {
    exposedVariables = []
  }
  return getExposedVariableWithIds(exposedVariables, target)
}

function getAltVariables (target, glitchApplications, availableGlitches) {
  if (target.isStage) {
    return []
  }
  const altVars = []
  glitchApplications.forEach(glitchApplication => {
    const glitch = availableGlitches.find(
      g => g.id === glitchApplication.glitchId
    )
    const exposedVariables = glitch.exposedVariables.filter(
      v => v.spriteName === '$other_sprites'
    ).map(
      v => ({
        ...v,
        spriteName: target.sprite.name
      })
    )
    exposedVariables.forEach(v => {
      if (!altVars.find(altVar => altVar.variableName === v.variableName)) {
        altVars.push(v)
      }
    })
  })

  return getExposedVariableWithIds(altVars, target)
}
module.exports = function VariablesPanel (state, emit) {
  const itemsPerPage = 5

  let target = state.vm.runtime.targets.find(
    t => t.id === state.selectedTargetId
  )
  if (!target) {
    target = state.vm.runtime.getTargetForStage()
    if (!target) {
      return ''
    }
  }
  let color = 'purple'
  let variablesToDisplay = []
  if (state.selectedGlitchApplicationId) {
    const glitchApplication = state.glitchApplications.find(
      g => g.id === state.selectedGlitchApplicationId
    )
    const glitch = state.availableGlitches.find(
      g => g.id === glitchApplication.glitchId
    );

    ({ color } = glitch)
    variablesToDisplay = getGlitchVariables(
      target,
      glitchApplication,
      state.availableGlitches
    )
  } else {
    const spriteVariables = getGameVariables(
      target,
      state.sceneMetadata,
      state.addedParts
    )
    const altVariables = getAltVariables(
      target,
      state.glitchApplications,
      state.availableGlitches
    )

    variablesToDisplay = spriteVariables.concat(altVariables)
  }

  const inputs = variablesToDisplay.map(
    gameVariable => generateInputElement(gameVariable, target, state, emit)
  )

  return PanelElement({
    color,
    size: state.isFullscreen ? 'fullscreen-large' : 'large',
    children: CarouselElement({
      selectedItem: state.currentVariablePage,
      items: paginateInputs(inputs, itemsPerPage),
      disabled: state.selectedVariableId !== null
        || state.isMenuOpen,
      onChange: state.selectedVariableId ? (
        () => false) : index => emit('select-variable-page', index)
    })
  })
}
